const EXCLUDED_ENV_VARS = [
    'USE_MRT_NEW_VARIABLES',
    'IS_MULTI_SITE_ENVIRONMENT'
]

const getFallbackSiteId = (appConfig) => {
    return appConfig?.commerceAPI?.parameters?.siteId || appConfig?.defaultSite || null
}

const getSiteScopedValue = (appConfig, envVariable, siteId) => {
    if (!siteId) {
        return null
    }

    // Backward-compatible shape: appConfig[ENV_VAR][siteId]
    const fromScopedMap = appConfig?.[envVariable]?.[siteId]

    return fromScopedMap || null
}

const getSiteEnvVarValue = (appConfig, envVariable, siteId) => {
    if (!appConfig || !envVariable) {
        return undefined
    }

    const orgConfigKeys = appConfig?.GLOBAL_CONFIG_KEYS || []
    const isMultiSiteEnvironment = appConfig?.IS_MULTI_SITE_ENVIRONMENT === 'true'
    if (!isMultiSiteEnvironment || orgConfigKeys.indexOf(envVariable) > -1 || EXCLUDED_ENV_VARS.indexOf(envVariable) > -1) {
        const val = appConfig?.[envVariable]
        return typeof val === 'boolean' ? String(val) : val
    }

    const explicitOrDefaultSiteId = siteId || getFallbackSiteId(appConfig)
    const resolvedExplicitValue = getSiteScopedValue(
        appConfig,
        envVariable,
        explicitOrDefaultSiteId
    )

    if (resolvedExplicitValue !== undefined) {
        return typeof resolvedExplicitValue === 'boolean' ? String(resolvedExplicitValue) : resolvedExplicitValue
    }

    const val = appConfig?.[envVariable]
    return typeof val === 'boolean' ? String(val) : val
}

module.exports = {getSiteEnvVarValue, getFallbackSiteId}
